module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_7005.02220f1c.png";